import React, { useState, useEffect, useRef } from "react";

const LazyMedia = ({ src, alt, className }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [attempt, setAttempt] = useState(0);
  const mediaRef = useRef();
  const placeholder = "/loading.png";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsLoaded(true);
          setImageSrc(src);
          observer.disconnect();
        }
      },
      { rootMargin: "300px", threshold: 0.05 }
    );
  
    const currentRef = mediaRef.current; // ✅ 현재 ref 값을 변수에 저장
  
    if (currentRef) observer.observe(currentRef);
  
    return () => {
      if (currentRef) observer.unobserve(currentRef); // ✅ 저장한 변수를 사용
      observer.disconnect();
    };
  }, [src]);
  

  const handleError = () => {
  if (attempt < 2) {
    setAttempt(attempt + 1);
    setTimeout(() => {
      setImageSrc(src + "?retry=" + attempt);
    }, 500); // 500ms 딜레이 후 재시도
  } else {
    setImageSrc(placeholder);
  }
};

  

  return (
    <img
      ref={mediaRef}
      src={imageSrc || placeholder}
      alt={alt || "Product Image"}
      className={className}
      onError={handleError}
      style={{
        opacity: isLoaded ? 1 : 0.5,
        transition: "opacity 0.3s ease-in-out",
      }}
    />
  );
};

export default React.memo(LazyMedia);
